'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = buildStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _AgentResponseTimeoutMiddleware = require('./email-capture/middleware/AgentResponseTimeoutMiddleware');

var _AgentResponseTimeoutMiddleware2 = _interopRequireDefault(_AgentResponseTimeoutMiddleware);

var _VisitorLastSeenMiddleware = require('./last-seen/middleware/VisitorLastSeenMiddleware');

var _VisitorLastSeenMiddleware2 = _interopRequireDefault(_VisitorLastSeenMiddleware);

var _VisitorNotificationMiddleware = require('./middleware/VisitorNotificationMiddleware');

var _VisitorNotificationMiddleware2 = _interopRequireDefault(_VisitorNotificationMiddleware);

var _visitorErrorMiddleware = require('./error-reporting/middleware/visitorErrorMiddleware');

var _realtime = require('./pubsub/middleware/realtime');

var _asyncActionTypes = require('./pubsub/constants/asyncActionTypes');

var _visitorUIRootReducer = require('./reducers/visitorUIRootReducer');

var _visitorUIRootReducer2 = _interopRequireDefault(_visitorUIRootReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCompose = function getCompose() {
  var shouldEnableDevTools = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

  if (shouldEnableDevTools) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      maxAge: 200,
      serialize: {
        options: {
          circular: '[CIRCULAR]'
        },
        immutable: _immutable2.default
      },
      // Ably's client is quite large and serializing it slows down redux devtools
      actionSanitizer: function actionSanitizer(action) {
        if (action.type === _asyncActionTypes.INITIALIZE_PUBSUB.SUCCEEDED) {
          return _extends({}, action, {
            payload: { client: '<< PUBSUB CLIENT >>' }
          });
        }

        return action;
      },
      stateSanitizer: function stateSanitizer(state) {
        if (state.pubSubClient.data) {
          return _extends({}, state, {
            pubSubClient: state.pubSubClient.set('data', '<< PUBSUB CLIENT >>')
          });
        }
        return state;
      }
    });
  }

  return _redux.compose;
};

function buildStore(initialState) {
  var middleware = [_reduxThunk2.default, _visitorErrorMiddleware.visitorErrorMiddleware, _VisitorLastSeenMiddleware2.default, _VisitorNotificationMiddleware2.default, _AgentResponseTimeoutMiddleware2.default, _realtime.realtime];

  var composeEnhancers = getCompose();

  return (0, _redux.createStore)(_visitorUIRootReducer2.default, initialState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middleware)));
}
module.exports = exports['default'];